/**
 * These types and enums are duplicated here **temporarily** to aid in removing the @doxyme/media library.
 * These types are here specifically as they were being used in libs/ui and libs/business-services.
 * Once all usages of these types are removed from libs/ui and libs/business-services, these types should be moved to apps/frontend/webrtc/media.
 * @TODO https://doxyme.atlassian.net/browse/PE-2222
 */

export enum Vendor {
  Vonage = 'Vonage',
}

export type VirtualBackgroundFilter = {
  type: 'backgroundBlur' | 'backgroundReplacement';
  blurStrength?: 'low' | 'high';
  backgroundImgUrl?: string;
};

export enum MediaAccessError {
  PermissionDenied = 'PermissionDenied',
  PermissionDeniedBySystem = 'PermissionDeniedBySystem',
  DeviceNotFound = 'DeviceNotFound',
  IncorrectConstraints = 'IncorrectConstraints',
  NoVideoAudioConstraints = 'NoVideoAudioConstraints',
  Error = 'Error',
}

/**
 * State of a Vonage/OpenTok SIP call leg as reported by Vonage SIP monitoring.
 * Forwarded from the server to session participants via the `sipCallState` signal.
 *
 * @link https://tokbox.com/developer/guides/sip/#monitoring-call-progress
 */
export type SipCallState =
  | 'DIALING'
  | 'RINGING'
  | 'ON_HOLD'
  | 'ACTIVE'
  | 'HANGUP';

/**
 * Status of a patient phone leg as reported by the Vonage Voice API event webhook.
 * Forwarded from the server to session participants via the `patientPhoneStatus` signal.
 *
 * @link https://developer.vonage.com/en/voice/voice-api/webhook-reference#event-webhook
 */
export type PatientPhoneStatus =
  | 'started'
  | 'ringing'
  | 'answered'
  | 'machine'
  | 'complete'
  | 'timeout'
  | 'failed'
  | 'rejected'
  | 'cancelled'
  | 'busy'
  | 'unanswered'
  | 'human'
  | 'recording';
